// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggested-match-metadata {
  margin-bottom: 6rem;
}
.suggested-match-metadata p {
  margin-bottom: 0.5rem !important;
}
.suggested-match-metadata p span {
  font-weight: 400;
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/MatchComponents/v2/SuggestedMatchMetadata/index.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACE;EACE,gCAAA;AACJ;AACI;EACE,gBAAA;EACA,oBAAA;AACN","sourcesContent":[".suggested-match-metadata {\n  margin-bottom: 6rem;\n\n  p {\n    margin-bottom: 0.5rem !important;\n\n    span {\n      font-weight: 400;\n      margin-right: 0.5rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
